import { combineReducers } from 'redux';
import testReducer from './containers/Test/reducer';
import createTaskReducer from './containers/CreateTask/reducer';
import tasksReducer from './containers/TasksList/reducer';
import loginReducer from './containers/Login/reducer';
import userReducer from './containers/User/reducer';
import alertReducer from './containers/Alert/reducer';
import { connectRouter } from 'connected-react-router';
import switchColorReducer from './containers/SwitchColor/reducer';
import spinnerReducer from './containers/Spinner/reducer';
import kanbanReducer from './containers/Kanban/reducer';
import drawerReducer from './containers/Drawer/reducer';
import calendarReducer from './containers/Calendar/reducer';

const rootReducer = (history) => combineReducers({
    router: connectRouter(history),
    test: testReducer,
    isFormIsOpen: createTaskReducer,
    tasks: tasksReducer, 
    auth: loginReducer,
    user: userReducer,
    alert: alertReducer,
    switchColor: switchColorReducer,
    kanban: kanbanReducer,
    spinner: spinnerReducer,
    isOpenDrawer: drawerReducer,
    googleEvents: calendarReducer,
});

export default rootReducer;
